import server from '../../api/server'
import router from '../../router'
// import moment from 'moment'

const state = {
  authorizingStarted: false,
  accessToken: null,
  breakpoint: null,
  status: {
    show: false,
    type: null,
    message: null,
    details: null
  },
  profile: {
    isHaveClient: null,
    isConfirmed: false,
    msg: '',
    nameShort: '',
    clientId: null,
    clientNameShort: ''
  },
  rights: {},
  accountClients: [],
  clientProfile: {
    isRefreshed: false,
    bankDetails: {
      account: '',
      bankName: '',
      corrAccount: '',
      bankBic: ''
    }
  },
  clientAccounts: {
  },
  dashboardCounters: {
    notReviewedChats: 0
  },
  messages () {
    return new Map([
      ['NOT_SPECIFIED', 'Что то пошло не так'],
      ['ACTION_NOTALLOWED', 'Действие не разрешено'],
      ['EMAIL_NOTFOUND', 'Адрес электронной почты не найден'],
      ['EMAIL_DUPLICATED', 'Адрес электронной почты уже зарегистрирован в системе'],
      ['EMAIL_WRONG', 'Неверный адрес электронной почты'],
      ['INN_WRONG', 'Неверный ИНН компании'],
      ['CONFIRMATION_CODE_WRONG', 'Неверный код подтверждения или истек срок действия кода'],
      ['SMS_PHONE_WRONG', 'Неверный номер телефона пользователя'],
      ['SMS_ERROR', 'Сервис СМС временно не доступен'],
      ['SMTP_CONFIG_WRONG', 'Ошибка конфигурации почтового сервера'],
      ['MACRO_WRONG', 'Ошибка обработки макроса'],
      ['INDIVIDUAL_DUPLICATED', 'Существует другая запись об этом контакте (ФИО и ИНН совпадают)'],
      ['EGRULAPI_TIMEOUT', 'Сервер не может обработать запрос, время ожидания истекло'],
      ['Internal Server Error', 'Внутренняя ошибка сервера'],
      ['invalid_grant', 'Пользователь с такими параметрами  входа не найден'],
      ['invalid_token', 'Ваша соединение устарело, необходимо снова войти в систему']
    ])
  },
  icons () {
    return new Map([
      ['head', 'dealger-crown'],
      ['holder', 'work'],
      ['sign', 'dealger-crown'],
      ['loner', 'school']
      // ['holder', 'dealger-chart-pie']
    ])
  }
}

// getters
const getters = {
  getLastLogin: state => nocache => { return server.getLastLogin() },
  getStatus: state => state.status,
  getProfile: state => state.profile,
  getProfileHaveClient: state => state.profile.haveClient !== null && state.profile.haveClient,
  getProfileLoaded: state => state.profile.isHaveClient !== null,
  getAccountClients: state => state.accountClients,
  getClientProfile: state => state.clientProfile,
  getClientMonitoring: state => state.profile.clientMonitoring !== null && state.profile.clientMonitorng,
  getClientAccounts: state => state.clientAccounts,
  //  TODO need refactor login routing
  getIsAuthorized: state => nocache => {
    return server.getAccessToken() !== null || state.authorizingStarted
  },
  getDashboardCounters: state => state.dashboardCounters,
  getIsAllow: state => (obj) => {
    var result = state.rights != null
    Object.entries(obj).forEach(([k, v]) => {
      var action = state.rights[k]
      result = result && action && Array.isArray(action) && (action.indexOf(String(v)) >= 0)
    })
    return result
  },
  getIconName: state => (name) => {
    return state.icons().get(name)
  },
  getIsMobile: state => state.breakpoint && state.breakpoint.xsOnly,
  getDialogHeight: state => {
    return state.breakpoint && (getters.getIsMobile(state) === true ? state.breakpoint.height : state.breakpoint.height * 0.9)
  },
  calcScroll: state => (delta, deltaMobile) => {
    if (getters.getIsMobile(state) === true) {
      return state.breakpoint.height - (deltaMobile || delta) + 'px'
    }
    // Main toolbar incresed to 64 on large screen
    if (state.breakpoint.mdAndUp) {
      delta = delta + 16
    }
    return state.breakpoint.height - delta + 'px'
  },
  calcDialogScroll: state => (delta, deltaMobile) => {
    if (getters.getIsMobile(state) === true) {
      return state.breakpoint.height - (deltaMobile || delta) + 'px'
    }
    return state.breakpoint.height * 0.9 - delta + 'px'
  },
  calcOfs: state => (delta, deltaMobile) => {
    if (getters.getIsMobile(state) === true) {
      return (deltaMobile || delta) + ''
    }
    return delta + ''
  },
  calcDialogOfs: state => (delta, deltaMobile) => {
    if (getters.getIsMobile(state) === true) {
      return (deltaMobile || delta) + ''
    }
    return state.breakpoint.height * 0.1 + delta + ''
  }
}

// actions
const actions = {
  login ({commit, state}, request) {
    commit('startAuthorizing')
    server.saveToStorage('lastLogin', request.username)
    server.login(request,
    () => {
      commit('finishAuthorizing')
      this.dispatch('fetchAccountProfile')
      commit('setSuccessStatus')
    },
    (e) => {
      this.dispatch('logout')
      commit('setErrorStatus', {error: e, context: 'Ошибка сервера при логине'})
    })
  },
  register ({commit, state}, request) {
    server.register(request,
    (data) => {
      // this.dispatch('fetchAccountProfile')
      commit('setStatus', {
        show: true,
        type: 'success',
        message: 'Пользователь ' + request.username + ' зарегистрирован в системе! Можете входить в систему! ' +
       'Вам на почту был направлен код подтверждения для ввода при заполнении профайла'})
    },
    (e) => {
      commit('setErrorStatus', {error: e, context: 'Ошибка сервера при регистрации'})
      this.dispatch('logout')
    })
  },
  logout ({commit, state}) {
    server.logout()
    commit('setProfile', null)
    commit('setClientCompany', null)
    commit('setClientProfile', null)
    commit('finishAuthorizing')
  },
  confirmEmail ({commit, state}, code) {
    server.apiPost(
      '/api/account/confirmEmail',
      code,
      (data) => {
        commit('setStatus', {
          show: true,
          type: 'success',
          message: 'Поздравляем! Ваша почта подтверждена, войдите заново и заполните личную информацию'
        })
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении кода подтверждения'})
        this.dispatch('logout')
      }
    )
  },
  fetchAccountProfile ({commit, state}) {
    server.apiGet(
      '/api/me/profile',
      (data) => {
        commit('setProfile', data)
        commit('setSuccessStatus')
        commit('cleanRights')
        this.dispatch('fetchDashboardCounters')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении профайла'})
      }
    )
  },
  fetchAccountClients ({commit, state}) {
    server.apiGet(
      '/api/me/profile/clients',
      (data) => {
        commit('setAccountClients', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении данных о полномочиях пользователя'})
      }
    )
  },
  fetchClientProfile ({commit, state}, force) {
    if (state.clientProfile.isRefreshed && !force) {
      return
    }
    server.apiGet(
      '/api/me/client',
      (data) => {
        data.isRefreshed = true
        commit('setClientProfile', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении данных о клиенте '})
      }
    )
  },
  fetchClientAccounts ({commit, state}) {
    server.apiGet(
      '/api/me/client/accounts',
      (data) => {
        commit('setClientAccounts', data)
        // статус перезатерает предыдущее информационное сообщение
        // commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении инфрмации о представителях клиента '})
      }
    )
  },
  getClientAccount ({commit, state}) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/client/account',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении инфрмации о пользователе в текущей компании'})
        }
      )
    })
  },
  fetchDashboardCounters ({commit, state}) {
    server.apiGet(
      '/api/me/dashboard/usercounters',
      (data) => {
        commit('setDashboardCounters', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о счетчиках '})
      }
    )
  },
  saveAccountProfile ({commit, state}, profile) {
    server.apiPost(
      '/api/me/profile',
      profile,
      (data) => {
        commit('setProfile', data)
        this.dispatch('fetchAccountProfile')
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении профайла '})
      }
    )
  },
  attachCompany ({commit, state}, request) {
    server.apiPost(
      '/api/me/profile/client',
      request,
      (data) => {
        commit('setStatus', {show: true, type: 'success', message: 'Запрос на проверку достоверности данных был послан Администратору'})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка формирования запроса подключения к компании  '})
      }
    )
  },
  setCurrentClient ({commit, state}, clientId) {
    server.saveToStorage('currentClient', clientId)
    server.refresh(null,
    (data) => {
      // при установки href происходит reload страницы и весь state обновляется
      location.href = '/'
    },
    (e) => {
      commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении токена'})
      this.dispatch('logout')
    })
  },
  updateFromEgrul ({commit, state}) {
    server.apiPost(
      '/api/me/client/command-egrul-updates',
      null,
      (data) => {
        this.dispatch('fetchClientProfile', true)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка при обновлении данных из ЕГРЮЛ '})
      }
    )
  },
  saveClientProfile ({commit, state}, profile) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/client',
        profile,
        (data) => {
          commit('setClientProfile', data)
          this.dispatch('fetchClientProfile', true)
          commit('setSuccessStatus')
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при обновлении профайла клиента '})
          reject(e)
        }
      )
    })
  },
  uploadPartnersFile ({commit, state, rootState}, {fileName, file}) {
    var fd = new FormData()
    fd.append('file', file)
    fd.append('json', new Blob([JSON.stringify({fileName: fileName})], {
      type: 'application/json'
    }))
    server.apiUpload(
      '/api/me/partner/uploads',
      fd,
      (data) => {
        commit('setStatus', {show: true, type: 'success', message: 'Список контрагентов был послан Администратору'})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при отсылке списка контрагентов '})
      }
    )
  },
  addClientAgent ({commit, state}, request) {
    server.apiPost(
      '/api/me/client/agents',
      request,
      (data) => {
        this.dispatch('fetchClientAccounts')
        var msg = request.username
        ? 'Пользователь ' + request.username + ' подключен к Вашей компании!' +
          ' На почту был направленj уведомление'
        : 'Пользователь ' + request.dto.clientEmail + ' зарегистрирован в системе и подключен к Вашей компании!' +
          ' На почту был направлен пароль для входа в систему'
        commit('setStatus', {
          show: true,
          type: 'success',
          message: msg})
      },
      (e) => {
        var msg = request.username
        ? 'Ошибка сервера при подключении пользователя ' + request.username + ' администратором компании '
        : 'Ошибка сервера при создании и подключении пользователя ' + request.dto.clientEmail + ' администратором компании '
        commit('setErrorStatus', {error: e, context: msg})
      }
    )
  },
  updateClientAgent ({commit, state}, agent) {
    server.apiPut(
      '/api/me/client/agents/' + agent.accountProfileId,
      agent,
      (data) => {
        this.dispatch('fetchClientAccounts')
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при обновлении пользователя администратором компании'})
      }
    )
  },
  removeClientAgent ({commit, state}, agent) {
    server.apiDelete(
      '/api/me/client/agents/' + agent.accountProfileId,
      (data) => {
        this.dispatch('fetchClientAccounts')
        commit('setStatus', {
          show: true,
          type: 'success',
          message: 'Пользователь ' + agent.clientEmail + ' был отключен от Вашей компании!' +
          ' На почту было направлено уведомление'})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при отключении от компании'})
      }
    )
  },
  refreshAgentPassword ({commit, state}, agent) {
    server.apiPost(
      '/api/me/client/actions/password-refreshes',
      agent.accountProfileId,
      (data) => {
        commit('setStatus', {
          show: true,
          type: 'success',
          message: 'Пароль пользователя ' + agent.clientEmail + ' был обновлен! ' +
          'На почту было направлено уведомление'})
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при сбросе пароля '})
      }
    )
  },
  getClientMailboxes ({commit, state, rootState}) {
    return new Promise((resolve, reject) => {
      server.apiGet(
      '/api/me/client/mailboxes',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка почтовых ящиков клиента '})
        }
      )
    })
  },
  getClientMailbox ({commit, state, rootState}, id) {
    return new Promise((resolve, reject) => {
      server.apiGet(
      `/api/me/client/mailboxes?ids=${id}`,
        (data) => {
          resolve(data && data.length > 0 && data[0] || null)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении почтового ящика клиента'})
        }
      )
    })
  },
  updateClientMailbox ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/client/command-mailbox-updates',
        {dto: request.dto},
        (data) => {
          this.dispatch('fetchFavoriteCompanies', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении почтового ящика клиента '})
        }
      )
    })
  },
  deleteClientMailbox ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.apiPost(
        '/api/me/client/command-mailbox-deletes',
        {ids: request.ids},
        (data) => {
          this.dispatch('fetchFavoriteCompanies', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении записей о почтовом ящике клиента '})
        }
      )
    })
  },
  fetchRights ({commit, state}, rights) {
    function serialize (obj) {
      return '?' + Object.keys(obj).reduce(
        function (a, k) {
          a.push(k + '=' + encodeURIComponent(obj[k]))
          return a
        }, []).join('&')
    }
    var queryString = serialize(rights)
    // Special serialization, it does not work with server.apiGetParams
    server.apiGet(
      '/api/me/rightsmap' + queryString,
      (data) => {
        commit('setRights', data)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о праах пользователя '})
      })
  }
}

// mutations
const mutations = {
  setStatus (state, status) {
    if (status.type === 'error') {
      status.show = true
    }
    if (status.show) {
      state.status = status
    }
  },
  closeAlert (state) {
    state.status.show = false
  },
  setProfile (state, profile) {
    if (!profile) {
      profile = {
        msg: '',
        nameShort: '',
        clientId: null,
        clientNameShort: ''
      }
    } else {
      if (!(profile && profile.ruleAgreed)) {
        if (router.currentRoute.name !== 'DocDlg') {
          router.push({name: 'Agreement'})
        }
      }
    }
    state.profile = profile
  },
  setClientProfile (state, profile) {
    if (!profile) {
      profile = {
        isRefreshed: false,
        inn: '',
        email: '',
        nameShort: '',
        address: '',
        phone: '',
        website: '',
        bankDetails: {
          account: '',
          bankName: '',
          corrAccount: '',
          bankBic: ''
        },
        notes: '',
        about: '',
        contacts: '',
        services: '',
        price: '',
        docs: '',
        tags: '',
        other: ''
      }
    }
    state.clientProfile = profile
  },
  setClientAccounts (state, data) {
    state.clientAccounts = data
  },
  startAuthorizing (state) {
    state.authorizingStarted = true
  },
  finishAuthorizing (state) {
    state.authorizingStarted = false
    if (!getters.getIsAuthorized()) {
      router.push('/login')
    } else {
      var rdUrl = router.currentRoute.query && router.currentRoute.query.redirect ? router.currentRoute.query.redirect : '/'
      router.push(rdUrl)
    }
  },
  setAccountClients (state, data) {
    state.accountClients = data
  },
  setSuccessStatus (state, msg) {
    if (!msg) {
      msg = 'Данные получены'
    }
    this.commit('setStatus', {show: false, type: 'success', message: msg})
  },
  setWarningStatus (state, msg) {
    if (!msg) {
      msg = 'Что то пошло не совсем так!'
    }
    this.commit('setStatus', {show: true, type: 'warning', message: msg})
  },
  setInfoStatus (state, msg) {
    this.commit('setStatus', {show: true, type: 'info', message: msg})
  },
  setErrorStatus (state, {error, context}) {
    var msg = error.message
    let details = null
    let type = 'error'
    if (!(error.response) && (error.message === 'Network Error')) {
      msg = 'Сервер не доступен'
      this.dispatch('logout')
    }
    if (error.response && error.response.data && error.response.data.code) {
      msg = state.messages().get(error.response.data.code)
      details = error.response.data.message
    }
    if (error.response && error.response.data && error.response.data.error) {
      msg = state.messages().get(error.response.data.error)
      if (error.response.status && error.response.status === 401) {
        this.dispatch('logout')
        this.commit('setInfoStatus', msg)
        return
      }
      if (error.response.status && error.response.status === 500) {
        details = error.response.data.message
      }
    }
    this.commit('setStatus', {type: type, message: context + ' ( ' + msg + ' )!', details: details})
  },
  setDashboardCounters (state, data) {
    state.dashboardCounters = data
  },
  cleanRights (state) {
    state.rights = {}
  },
  setRights (state, data) {
    Object.entries(data).forEach(([k, v]) => {
      var action = state.rights[k]
      state.rights[k] = Array.from(new Set(Array.isArray(action) ? action.concat(v) : v))
    })
    state.rights = Object.assign({}, state.rights)
  },
  setBreakpoint (state, value) {
    // console.log('setMobile', value)
    state.breakpoint = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/context.js